import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Container = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 5%;
  margin: 0 auto;
  text-align: center;
  z-index: 2;
`;

const Pip = styled.span`
  background: #fff;
  opacity: ${props => (props.isCurrent ? '1' : '.48')};
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 10px;
  display: inline-block;
  // box-shadow: 0 0 5px 5px rgba(0, 0, 0, .1);
  transition: background 0.5s ease;
`;

class Indicator extends React.Component {
  static propTypes = {
    length: PropTypes.number.isRequired,
    position: PropTypes.number.isRequired,
  }

  render() {
    const { length, position } = this.props;
    return (
      <Container>
        {
          Array.from({ length }, (pip, i) => (
            <Pip
              key={i}
              isCurrent={i === position}
            />
          ))
        }
      </Container>
    );
  }
}

export default Indicator;
